const INDIAN_UNITS = {
  actual: { label: "Actual", divisor: 1, suffix: "", locale: "en-IN" },
  K: { label: "Thousands", divisor: 1_000, suffix: " K", locale: "en-IN" },
  L: { label: "Lakhs", divisor: 100_000, suffix: " L", locale: "en-IN" },
  Cr: { label: "Crores", divisor: 10_000_000, suffix: " Cr", locale: "en-IN" },
};

const INTERNATIONAL_UNITS = {
  actual: { label: "Actual", divisor: 1, suffix: "", locale: "en-US" },
  K: { label: "Thousands", divisor: 1_000, suffix: " K", locale: "en-US" },
  M: { label: "Millions", divisor: 1_000_000, suffix: " M", locale: "en-US" },
  B: { label: "Billions", divisor: 1_000_000_000, suffix: " B", locale: "en-US" },
};

export const DASHBOARD_NUMBER_FORMATS = {
  auto: "auto",
  indian: "indian",
  international: "international",
};

export function normalizeDashboardNumberFormat(value) {
  const text = String(value || "").trim().toLowerCase();
  return text === "indian" || text === "international" ? text : "auto";
}

export function resolveDashboardNumberFormat(value, tenantMeta = {}) {
  const normalized = normalizeDashboardNumberFormat(value);
  if (normalized !== "auto") return normalized;
  const license = String(tenantMeta?.license_number || tenantMeta?.licenseNumber || tenantMeta?.name || "").trim().toUpperCase();
  return license.startsWith("R360-AE-") ? "international" : "indian";
}

export function unitDefinitionsForNumberFormat(numberFormat = "indian") {
  return numberFormat === "international" ? INTERNATIONAL_UNITS : INDIAN_UNITS;
}

export function dashboardAmountUnitOptions(numberFormat = "indian") {
  const units = unitDefinitionsForNumberFormat(numberFormat);
  return [
    { value: "auto", label: "Auto" },
    ...Object.entries(units).map(([value, cfg]) => ({ value, label: cfg.label })),
  ];
}

function safeNumber(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n : 0;
}

export function chooseDashboardAmountUnit(values = [], numberFormat = "indian") {
  const max = Math.max(...(values || []).map((value) => Math.abs(safeNumber(value))), 0);
  if (numberFormat === "international") {
    if (max >= 1_000_000_000) return "B";
    if (max >= 1_000_000) return "M";
    if (max >= 1_000) return "K";
    return "actual";
  }
  if (max >= 10_000_000) return "Cr";
  if (max >= 100_000) return "L";
  if (max >= 1_000) return "K";
  return "actual";
}

export function normalizeDashboardAmountUnit(unit, numberFormat = "indian") {
  const units = unitDefinitionsForNumberFormat(numberFormat);
  const text = String(unit || "").trim();
  if (!text) return "actual";
  if (text === "auto") return "auto";
  return units[text] ? text : "actual";
}

export function formatDashboardAmount(value, { unit = "auto", numberFormat = "indian", digits = 2 } = {}) {
  const resolvedUnit = normalizeDashboardAmountUnit(unit, numberFormat);
  const actualUnit = resolvedUnit === "auto" ? chooseDashboardAmountUnit([value], numberFormat) : resolvedUnit;
  const units = unitDefinitionsForNumberFormat(numberFormat);
  const cfg = units[actualUnit] || units.actual;
  const scaled = safeNumber(value) / cfg.divisor;
  const fractionDigits = actualUnit === "actual" ? 0 : digits;
  return `${scaled.toLocaleString(cfg.locale, { maximumFractionDigits: fractionDigits })}${cfg.suffix}`;
}
